import {
  //   Linkedin,
  //   Instagram,
  //   Twitter,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { FaInstagram, FaLinkedin } from "react-icons/fa6";

function FooterLink({ href = "#", children }) {
  return (
    <a
      href={href}
      className="font-manrope text-sm text-slate-400 hover:text-gold transition-colors duration-200"
    >
      {children}
    </a>
  );
}

const socialLinks = [
  {
    icon: FaLinkedin,
    href: "https://linkedin.com/company/greatcalcy",
  },
  {
    icon: FaInstagram,
    href: "https://instagram.com/greatcalcy",
  },
  {
    icon: Mail,
    href: "https://twitter.com/greatcalcy",
  },
];

const quickLinks = [
  { label: "Home", href: "#" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Updates", href: "#updates" },
  { label: "Contact Us", href: "#contact" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "#" },
  { label: "Terms of Service", href: "#" },
  { label: "Disclaimer", href: "#" },
];

const offices = [
  {
    flag: "🇮🇳",
    name: "Greatcalcy Accounts and Tax Consultancy LLP",
    location: "Mumbai, Maharashtra",
    phone: "+91 99672 90235",
  },
  {
    flag: "🇨🇦",
    name: "Greatcalcy Bookkeeping Inc",
    location: "Alberta, Canada",
    phone: "+1 403 829 9209",
  },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-[1280px] mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand */}
          <div className="space-y-5">
            <div>
              <div className="font-manrope text-[20px] font-extrabold tracking-tighter">
                Greatcalcy
              </div>
              <div className="font-manrope text-[9px] font-bold tracking-[0.2em] uppercase text-gold/70">
                Accounts & Tax Consultancy
              </div>
            </div>

            <p className="text-sm text-white/50 max-w-xs">
              Bridging the gap between traditional trust and modern agility for SMEs globally.
            </p>

            {/* Social Icons */}
            <div className="flex gap-3">
              {socialLinks.map((item, i) => {
                const Icon = item.icon;
                return (
                  <a
                    key={i}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-lg hover:bg-gold hover:border-gold transition-all"
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Reach Us */}
          <div className="space-y-5">
            <div className="text-label-caps text-gold">REACH US</div>

            {offices.map((o, i) => (
              <div key={i} className="space-y-1">
                <p className="text-[12px] font-bold text-white/80">
                  {o.flag} {o.name}
                </p>

                <div className="flex items-center gap-2 text-sm text-white/40">
                  <MapPin size={14} />
                  {o.location}
                </div>

                <div className="flex items-center gap-2 text-sm text-gold/80">
                  <Phone size={14} />
                  {o.phone}
                </div>
              </div>
            ))}

            <div className="flex items-center gap-2 text-sm text-white/40 pt-1">
              <Mail size={14} />
              info@greatcalcy.co.in
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <div className="text-label-caps text-gold">QUICK LINKS</div>
            <div className="flex flex-col gap-3">
              {quickLinks.map((l) => (
                <FooterLink key={l.label} href={l.href}>
                  {l.label}
                </FooterLink>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <div className="text-label-caps text-gold">LEGAL</div>
            <div className="flex flex-col gap-3">
              {legalLinks.map((l) => (
                <FooterLink key={l.label} href={l.href}>
                  {l.label}
                </FooterLink>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30">
            © 2026 Greatcalcy. All rights reserved.
          </p>

          <p className="text-xs text-white/20">
            India • Canada • USA
          </p>
        </div>
      </div>
    </footer>
  );
}